export interface DiffLine {
  type: 'CONTEXT' | 'ADD' | 'DEL';
  text: string;
}

export function diffLines(from: string[], to: string[]): DiffLine[] {
  const fromLineCount = from.length;
  const toLineCount = to.length;
  const lcsLength: number[][] = Array.from(
    { length: fromLineCount + 1 },
    () => new Array(toLineCount + 1).fill(0),
  );

  for (let fromIndex = fromLineCount - 1; fromIndex >= 0; fromIndex -= 1) {
    for (let toIndex = toLineCount - 1; toIndex >= 0; toIndex -= 1) {
      lcsLength[fromIndex][toIndex] = from[fromIndex] === to[toIndex]
        ? lcsLength[fromIndex + 1][toIndex + 1] + 1
        : Math.max(lcsLength[fromIndex + 1][toIndex], lcsLength[fromIndex][toIndex + 1]);
    }
  }

  const diff: DiffLine[] = [];
  let fromIndex = 0;
  let toIndex = 0;

  while (fromIndex < fromLineCount && toIndex < toLineCount) {
    if (from[fromIndex] === to[toIndex]) {
      diff.push({ type: 'CONTEXT', text: from[fromIndex] });
      fromIndex += 1;
      toIndex += 1;
    } else if (lcsLength[fromIndex + 1][toIndex] >= lcsLength[fromIndex][toIndex + 1]) {
      diff.push({ type: 'DEL', text: from[fromIndex] });
      fromIndex += 1;
    } else {
      diff.push({ type: 'ADD', text: to[toIndex] });
      toIndex += 1;
    }
  }
  while (fromIndex < fromLineCount) {
    diff.push({ type: 'DEL', text: from[fromIndex] });
    fromIndex += 1;
  }
  while (toIndex < toLineCount) {
    diff.push({ type: 'ADD', text: to[toIndex] });
    toIndex += 1;
  }

  return diff;
}
